<script>
import { CellGroup, Cell } from 'vant'
import ImageViewer from '@/components/org/ImageViewer'
import BottomToolbar from '@/components/org/BottomToolbar'
import { QNImageUtil } from '@/utils'

export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
	name: 'org-team-detail',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'van-cell-group': CellGroup,
        'van-cell': Cell,
        'image-viewer': ImageViewer,
        'bottom-toolbar': BottomToolbar,
    },

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
	emits: ['custom-event'],

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            player: {
                id: null,
                matchGroupId: null,
                matchId: null,
                teamId: null,
                name: null,
                logoUrl: null,
                num: null,
                genderLabel: null
            },
            locale: {}
        }
    },

    //--------------------------------------------------
    // computed setter and getter
    //--------------------------------------------------
    computed: {
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        onEditBtnClick() {
            console.log('onEditBtnClick')
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    name: 'OrgEditPlayer',
                    params: { id: this.player.id },
                    query: { 
                        matchGroupId: this.player.matchGroupId,
                        matchId: this.player.matchId,
                        teamId: this.player.teamId,
                    }
                }
            })
        },
        /**
         * @private
         * Adjust the image url according to the width and height.
         * @param img The identifier string for the image source.
         * @param w The image width number.
         * @param h The image height number.
         * @return The completed full url string.
         */
		adjustImageSize(img, w, h) {
            // console.log('adjustImageSize', img, w, h)
            if (img) {
                return QNImageUtil.imageView(img, w, h)
            }
			else {
                return null
            }
		},
    },
}
</script>

<template>
    <div class="player-detail">
        <van-cell-group>
            <van-cell :title="locale['player-name-label']" :value="player.name"/>
            <van-cell :title="locale['player-gender-label']" :value="player.genderLabel"/>
            <image-viewer
                :label="locale['player-logo-label']"
                :imageUrl="adjustImageSize(player.logoUrl, 160, 160)"
                :previewImageUrl="adjustImageSize(player.logoUrl, 750, 750)"
            />
            <van-cell :title="locale['player-num-label']" :value="player.num"/>
        </van-cell-group>
        <bottom-toolbar 
            type="button" 
            :mainButtonLabel="locale['edit']"
            @click-main-button="onEditBtnClick"
        />
    </div>
</template>